import { useTranslation } from '@/i18n';
import {
  ActionMenu,
  type ButtonV2Props,
  IconTrailing,
} from '@moneyforward/ap-frontend-components';
import { FC, useMemo } from 'react';
import type { ActionMenusProps } from '../types';
import { useItems } from './useItems';

export const ActionMenus: FC<ActionMenusProps> = ({
  onExport,
  dropDownProps,
  isDisabled,
  isLoading,
}) => {
  const { t } = useTranslation();
  const items = useItems({ onExport });

  const buttonProps: ButtonV2Props = useMemo(
    () => ({
      children: t('invoice_reports.button_groups.export'),
      isTertiary: true,
      rightIcon: <IconTrailing size={16} />,
      isDisabled: isDisabled || isLoading,
      isLoading,
      size: 'sm',
    }),
    [isDisabled, isLoading, t]
  );

  return (
    <ActionMenu
      type='button'
      items={items}
      buttonProps={buttonProps}
      dropDownProps={dropDownProps}
    />
  );
};
